<template>
  <el-form-item :label="i18nt('designer.setting.appendButtonIcon')">
    <icon-picker v-model="optionModel.buttonIcon"></icon-picker>
  </el-form-item>
</template>

<script>
  import i18n from "../../../../utils/i18n"
  import IconPicker from "../../../icon-picker/index";

  export default {
    name: "buttonIcon-editor",
    components: {IconPicker},
    mixins: [i18n],
    props: {
      designer: Object,
      selectedWidget: Object,
      optionModel: Object,
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// buttonIcon-editor.vue?4595da8f